module.exports = __webpack_public_path__ + "static/RUmobSlide6-1b500c6379b40f941e5dca42cec85983.jpg";